import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import JobApi from 'api/job';
import ContentSpinner from 'components/ui/ContentSpinner';

import JobCard from './JobCard';
import NoJobRecords from './NoJobRecords';

const JobList = ({ botId }) => {
  const { t } = useTranslation();

  const { data, isLoading } = useQuery(['jobs', botId], () => JobApi.fetch({ bot_id: botId }), {
    refetchInterval: 1000,
  });

  if (isLoading) {
    return <ContentSpinner />;
  }

  if (!(data || []).length) {
    return <NoJobRecords botId={botId} />;
  }

  const last_jobs_data = data.filter(job => job.status !== 'WORKING');
  const working_jobs_data = data.filter(job => job.status === 'WORKING');

  const renderJobs = (data, label_key) => {
    const jobs = data.map(job => (
      <div className={`${job.status === 'WORKING' ? 'mb-4' : 'mb-1'} col-12 col-md-9`} key={job.id}>
        <JobCard {...job} />
      </div>
    ));

    if (!jobs.length) {
      return null;
    }

    return (
      <>
        <h6 className="col-12 col-md-9 mt-5 mb-3 text-muted">{t(label_key)}</h6>
        {jobs}
      </>
    );
  };

  return (
    <section className="section d-flex flex-column align-items-center">
      {renderJobs(working_jobs_data, 'bots.jobs.sections.working.title')}
      {renderJobs(last_jobs_data, 'bots.jobs.sections.last_jobs.title')}
    </section>
  );
};

export default JobList;
